import { apm } from '@elastic/apm-rum';
import { Button } from '@mui/material';
import React from 'react';
import { ColorPalette } from '../components/config/color-palette';
import { win } from '../utilities/window';
import { getUserManager } from './auth-initialize';
import { bffLogoutUrl, isCookieSession } from './bff-session';

function logOut() {
  if (isCookieSession()) {
    win.location.assign(bffLogoutUrl());
    return;
  }
  getUserManager()
    ?.signoutRedirect()
    .catch((error: unknown) => apm.captureError(error as Error));
}

export function LogoutButton() {
  return (
    <Button variant="outlined" size="small" onClick={logOut} sx={{ color: ColorPalette.WHITE, borderColor: ColorPalette.WHITE, mx: 1, whiteSpace: 'nowrap' }}>
      Log ud
    </Button>
  );
}
